<template>
    <v-dialog v-model="shown" width="500px">
        <v-card>
            <v-card-title class="headline">Brake Check Report</v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-flex sx12>
                        <v-menu
                            v-model="dateDialog"
                            max-width="290px"
                            :close-on-content-click="false"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="formattedDate"
                                    label="End of Week?"
                                    readonly
                                    v-validate="'required'"
                                    :error-messages="errors.collect('date')"
                                    name="date"
                                    v-on="on"
                                    required
                                    append-icon="event"
                                    @click:append="dateDialog = true"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                class="mt-2 mb-3 elevation-0"
                                min="2019-01-01"
                                :max="maxDate"
                                no-title
                                :allowed-dates="allowedDates"
                                @change="dateDialog = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                            :items="vehicleUserGarageLocations"
                            item-text="location"
                            item-value="id"
                            v-model="garageLocationId"
                            name="garage"
                            placeholder="Select a garage"
                            required
                            v-validate="'required'"
                            solo
                        ></v-select>
                    </v-flex>

                    <v-flex xs12 v-if="files && files.length">
                        <h4 class="mt-5 mb-3">Form(s) to download:</h4>
                        <ul class="px-5">
                            <li v-for="file in files" :key="file.name">
                                <a @click="downloadFile($event, file)">{{file.name}}</a>
                            </li>
                        </ul>
                    </v-flex>
                    <v-flex xs12 v-if="files && !files.length">
                        <h4 class="mt-5 mb-3">NO BRAKE CHECKS FOUND</h4>
                    </v-flex>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="submit" :loading="generating">Generate</v-btn>
                <v-btn text @click="shown=false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import BrakeCheckClient from '@/components/BrakeChecks/BrakeCheckClient.vue';
  import GarageLocationClient from '@/components/GarageLocations/GarageLocationsClient.vue';
  import moment from 'moment';
  import {DateFormat} from '@/plugins/date-filter';
  import FormValidation from '../FormValidation.vue';
  import DownloadHelper from '@/lib/DownloadHelper';

  export default {
    mixins: [BrakeCheckClient, GarageLocationClient, FormValidation],
    data() {
      return {
        shown: false,
        date: null,
        maxDate: moment(new Date())
          .add(7, 'days')
          .format(DateFormat.Canonical),
        garageLocationId: null,
        files: null,
        generating: false,
        dateDialog: false
      };
    },
    computed: {
      vehicleUserGarageLocations() {
        return this.vehicleGarageLocations.filter(x => this.userGarages.find(g => g === x.id));
      },
      formattedDate() {
        if (!this.date) {
          return '';
        }
        return moment(this.date).format(DateFormat.Canonical);
      }
    },
    methods: {
      async show() {
        await this.getVehicleGarageLocations();
        await this.loadUserGarages();
        const garage = this.vehicleGarageLocations.find(x => x.id === this.userGarage);
        this.garageLocationId = garage ? garage.id : null;
        this.shown = true;
      },
      allowedDates(val) {
        return moment(val).isoWeekday() == 5;
      },
      async submitForm() {
        this.generating = true;
        this.files = [];
        let response = await this.generateReport(this.garageLocationId, this.date);

        for (let i = 0; i < response.length; i++) {
          this.files.push({
            name: `FRM-GEN-210-02_${moment(this.date).format(DateFormat.Canonical)}_${i + 1}.docx`,
            data: new Blob(DownloadHelper.parseBlob(response[i]), {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'})
          });
        }
        this.generating = false;
      },
      downloadFile(evt, file) {
        evt.stopPropagation();
        evt.preventDefault();
        DownloadHelper.download(file.name, file.data);
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>
